import clsx from 'clsx';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { dashboardUrl } from '../../../../../ClientRoutes';
import { T } from '../../../../../Translations';
import BreadCrumbSeparatorIcon from '../../../../Cutesies/BreadCrumbSeparatorIcon';

interface Props {
  name: string;
}

function Breadcrumb({ name }: Props) {
  return (
    <div className={'mb-7 flex'}>
      <NavLink
        to={dashboardUrl}
        className={clsx(
          'text-sm text-primary hover:underline hover:decoration-primary',
          'hover:decoration-2 hover:underline-offset-4',
        )}
      >
        <T kind="Learning Collections" />
      </NavLink>
      <span className="mr-3 ml-3 mt-0.5">
        <BreadCrumbSeparatorIcon />
      </span>
      <span className="text-sm">
        <T kind="Course Deep Links for {{name}}" name={name} />
      </span>
    </div>
  );
}

export default observer(Breadcrumb);
